import Logger from '../tools/Logger';

// our local logger instance
const log = Logger.child({
  component: 'PageVisibility',
});

// Set the name of the hidden property and the change event for visibility
let hidden: $TSFixMe;
let visibilityChange: $TSFixMe;
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof (document as $TSFixMe).mozHidden !== 'undefined') {
  hidden = 'mozHidden';
  visibilityChange = 'mozvisibilitychange';
  // @ts-expect-error TS(2551) FIXME: Property 'msHidden' does not exist on type 'Docume... Remove this comment to see the full error message
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof (document as $TSFixMe).webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

export function isSupported(): boolean {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return !(typeof document[hidden] === 'undefined');
}

function checkSupport(): void {
  if (!isSupported()) {
    log.error('Hidden properties not supported in this browser');
  }
}

export function isHidden(): boolean {
  checkSupport();
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return !!document[hidden];
}

export function addVisibilityHandler(handler: $TSFixMe): void {
  checkSupport();
  document.addEventListener(visibilityChange, handler, false);
}

export function removeVisibilityHandler(handler: $TSFixMe): void {
  checkSupport();
  document.removeEventListener(visibilityChange, handler, false);
}

const defaultOffsets = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export function isElementInViewport(
  element: $TSFixMe,
  viewportOffsets: $TSFixMe,
  staticHeight: $TSFixMe,
): boolean {
  if (!window || !element) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  const bottomRectPosition = staticHeight ? rect.top + staticHeight : rect.bottom;
  const offsets = { ...defaultOffsets, ...viewportOffsets };

  return (
    rect.top - offsets.top > 0 && // when first rendered Chrome sometimes incorrectly says top is 0
    rect.left - offsets.left >= 0 &&
    bottomRectPosition + offsets.bottom <= window.innerHeight &&
    rect.right + offsets.right <= window.innerWidth
  );
}
